import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const families: RouteRecordRaw = {
  name: 'admin.families',
  path: 'families',
  component: () => import('pages/Families.vue'),
  meta: {
    roles: [
      Roles.CenterAdmin,
      Roles.OfficeStaff,
      Roles.OrgAdmin,
      Roles.SuperAdmin,
    ],
    supportedPlatforms: ['desktop'],
    excludeEnv: [],
  },
}
